// -----------------------------
// Matchers
// -----------------------------

import { ContextEngine } from '@/types';

export function matchByUrl(
  url: string,
  pageTypeConfig: ContextEngine.PageTypeConfig
): boolean {
  return (pageTypeConfig.urlPatterns || []).some(re => re.test(url));
}

export function matchByDom(
  doc: Document,
  pageTypeConfig: ContextEngine.PageTypeConfig
): boolean {
  return (pageTypeConfig.domSelectors || []).some(sel =>
    doc.querySelector(sel)
  );
}
